// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".mmb-captcha {\n  margin-top: 2rem;\n  display: flex;\n  justify-content: center;\n}\n\n@media (min-width: 991px) {\n  .page-container {\n    height: calc(100vh - 122px) !important;\n  }\n}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
